/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef, useMemo } from "react";
import { useDracoGLTF } from "../../../../utils/useDracoGLTF";
import { findObjectStartsWithKey } from "../../../../utils/FindObjects";
import { DoubleSide, ShaderMaterial } from "three";
import { useFrame, useThree } from "@react-three/fiber";

import waterVertexShader2 from "../../shader/waterVert_3.glsl";
import waterFragShader2 from "../../shader/waterFrag_3.glsl";

const RinginductorWater = React.forwardRef(({ parentName, ...props }, ref) => {
  const group = useRef();
  const { nodes, materials } = useDracoGLTF("./models/heat/Ringinductor_Water.glb");
  const { scene } = useThree();

  const waterMaterial = useMemo(() => {
    var mat3 = new ShaderMaterial({
      fragmentShader: waterFragShader2,
      vertexShader: waterVertexShader2,
      vertexColors: true,
      transparent: true,
      depthWrite: false,
      side: DoubleSide,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 1.1,
        },
        uNoiseScale: {
          value: 15,
        },
        uDisplacement: {
          value: 0.002,
        },
        uFadeIn: {
          value: 1,
        },
      },
    });

    return mat3;
  }, []);

  useEffect(() => {
    if (parentName) {
      var parent = findObjectStartsWithKey(parentName, scene);

      if (parent && group.current) {
        parent.add(group.current);
        group.current.position.set(-0.0, -0.1, 0.0065);
      }
    }
  }, [scene, group.current]);

  useFrame(({ clock, ...state }) => {
    waterMaterial.uniforms.uTime.value = clock.elapsedTime;
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.Ringinductor_Water.geometry}
        material={waterMaterial}
        // position={[-0.0, -0.1, 0.0065]}
        rotation={[Math.PI / 2, 0, Math.PI * 1.9]}
        scale={100}
        ref={ref}
      >
        {/* <meshBasicMaterial transparent depthTest={false} wireframe /> */}
      </mesh>
      {/* <mesh scale={1}>
          <boxGeometry />
          <meshBasicMaterial
            transparent
            depthTest={false}
            color="red"
            side={DoubleSide}
          />
        </mesh> */}
    </group>
  );
});

export default RinginductorWater;

useDracoGLTF.preload("./models/heat/Ringinductor_Water.glb");
